@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.rides
import com.narbase.letsgo.dto.core.KmmLong

import com.narbase.letsgo.dto.DtoName
import com.narbase.letsgo.dto.core.DateTimeDto
import com.narbase.letsgo.web.dto.ridephonenumber.PhoneNumberDto
import com.narbase.letsgo.web.models.RideStatus
import com.narbase.letsgo.web.models.RideType
import com.narbase.letsgo.web.models.UserType

class RideDto (
    val id : KmmLong?,
    val carType: String?,
    val destAddress : String?,
    val destLat : Double?,
    val destLng : Double?,
    val pickupAddress : String,
    val pickupLat : Double,
    val pickupLng : Double,
    val notes: String?,
    val price: Int?,
    val discount: Double?,
    val callCenterCost: Double?,
    val ridePromoDiscount: Double?,
    @Suppress("NON_EXPORTABLE_TYPE") val status: DtoName<RideStatus>,
    val time: DateTimeDto,
    val driverId: KmmLong?,
    val passengerId: KmmLong?,
    @Suppress("NON_EXPORTABLE_TYPE") val rideType: DtoName<RideType>,
    val rating: Double?,
    val review: String?,
    val bookingKey: String?,
    val statusTimestamp: DateTimeDto?,
    val cancellationReason: String?,
    val senderId: KmmLong?,
    val ridePromoId: KmmLong?,
    val carTypeId: Int?,
    val currencyId: Int?,
    val flagPercentage: Double?,
    val byCallCenter: KmmLong?,
    val distanceInKm: Double?,
    val durationInMin: Double?,
    val reorderOff: KmmLong?,
    val requestedCarTypeId: Int?,
    val ratedByCallCenter: KmmLong?,
    val priceDetails: PriceDetailsDto?,
    val reviewedOn: DateTimeDto?,
    val isQuick: Boolean,
    val isGpsPickupLocation: Boolean,
    val additionalInfo: AdditionalRideInfoDto?
)
class PriceDetailsDto(
    val flagDown: Double?,
    val flagDownCommission: Double?,
    val markup: Double?,
    val markupCommission: Double?,
    val orderingIncentive: Double?,
    val timeoutIncentive: Double?,
    val isTimeoutIncentiveCalculated: Boolean?,
)

class AdditionalRideInfoDto(
    val isAppRide: Boolean,
    val timeoutOffsetSeconds: Int,
    val cancelledBy: DtoName<UserType>?,
    val isOnTheWayNotificationSent : Boolean = false
)

class NewAdminRideRequestDto(
    val passengerId : KmmLong,
    val pickupLat: Double,
    val pickupLng: Double,
    val pickupAddress: String,
    val destLat: Double?,
    val destLng: Double?,
    val destAddress: String?,
    val carType: String,
    val carTypeId: Int,
    val time: DateTimeDto?,
    val notes: String,
    val priceAfterDiscount: Int?,
    val fcmToken: String?,
    val voipToken: String? = null,
    val priceBeforeDiscount: Int?,
    val senderKey: String?,
    val currencyId: Int?,
    val priceToken: String?,
    val isGpsPickupLocation: Boolean,
    val phoneNumber: PhoneNumberDto,
    val isAppRide: Boolean
)


class NewRideRequestDto(
    val pickupLat: Double,
    val pickupLng: Double,
    val pickupAddress: String,
    val destLat: Double,
    val destLng: Double,
    val destAddress: String,
    val carType: String,
    val carTypeId: Int,
    val time: DateTimeDto?,
    val notes: String,
    val priceAfterDiscount: Int,
    val priceBeforeDiscount: Int,
    val currencyId: Int?,
    val priceToken: String?,
    val isGpsPickupLocation: Boolean,
)

class OpenRideRequestDto(
    val pickupLat: Double,
    val pickupLng: Double,
    val pickupAddress: String,
    val carType: String,
    val carTypeId: Int,
    val time: DateTimeDto?,
    val notes: String,
    val isGpsPickupLocation: Boolean,
)

class ReorderRideRequestDto(
    val rideId: KmmLong,
    val priceToken: String?,
    val carType: String?,
    val carTypeId: Int?,
)